// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__27mb4","paramInput":"JobSimulator_paramInput__3bhyy","input":"JobSimulator_input__yoVKr"};